import { useMemo } from 'react';
import { IPageLayoutProps } from '@diana/core';
import { ToolsDrawerHeader } from './ToolsDrawerHeader';
import { ToolsDrawerContent } from './ToolsDrawerContent';
import { useFlowBuilder2PageContext } from '../../Context/useFlowBuilder2PageContext';

export const useToolsDrawer = (): NonNullable<IPageLayoutProps['leftDrawer']> => {
  const { isLoading } = useFlowBuilder2PageContext();

  return useMemo(
    () => ({
      isOpen: true,
      isLoading,
      hidePageClosedPanel: true,
      isCustomHeader: true,
      header: <ToolsDrawerHeader />,
      content: <ToolsDrawerContent />,
    }),
    [isLoading],
  );
};
